export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] flex items-center overflow-hidden" id="contribute">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20dark%20city%20night%20scene%20with%20neon%20red%20and%20warm%20amber%20lights%20crowd%20of%20people%20from%20above%20blurred%20motion%20urban%20atmosphere%20cinematic%20editorial%20photography%20mysterious%20vibe&width=1800&height=600&seq=cta-bg-02&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-end">
          <div className="flex flex-col">
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-[1.1] mb-4">
              有料要爆？
              <br />
              立即投稿
            </h2>
            <a href="#contribute" className="btn-primary flex items-center gap-2 w-fit mt-6">
              <span>投稿入口</span>
              <span className="w-5 h-5 flex items-center justify-center bg-white/20 rounded-full">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
          </div>

          <div className="text-white/80 text-sm md:text-base leading-relaxed font-label lg:text-right">
            <p className="mb-2">全网实时更新 &middot; 吃瓜群众在线验证</p>
            <p>独家线索一经采纳，即可获得现金奖励</p>
          </div>
        </div>
      </div>
    </section>
  );
}